// src/pwa/src/services/emailService.ts
// Issue 74 — email transport. Tries the Cloudflare email worker endpoint first
// (full SMTP delivery with PDF attachment). Falls back to a mailto: open so
// the user can use their desktop mail client even when the SMTP route is
// offline.

import { blobToBase64 } from './pdfService';

export interface SendEmailArgs {
    to?: string;
    subject: string;
    body: string;
    attachment?: { filename: string; pdf: Blob };
    fromUser?: string;
}

export interface SendEmailResult {
    delivered: boolean;
    method: 'mailto' | 'api' | 'queued';
    fallbackUri?: string;
}

export async function sendEmail(args: SendEmailArgs): Promise<SendEmailResult> {
    let base64: string | undefined;
    if (args.attachment) {
        base64 = await blobToBase64(args.attachment.pdf);
    }

    // Prefer the worker's email endpoint (full SMTP via Resend or equivalent).
    try {
        const res = await fetch('/api/email/send', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                to: args.to,
                from: args.fromUser || 'noreply@bizbuilder.local',
                subject: args.subject,
                text: args.body,
                attachments: args.attachment
                    ? [{ filename: args.attachment.filename, contentBase64: base64 }]
                    : undefined,
            }),
        });
        if (res.ok) {
            return { delivered: true, method: 'api' };
        }
    } catch {
        // fall through to mailto
    }

    const params = new URLSearchParams({ subject: args.subject, body: args.body });
    const uri = `mailto:${encodeURIComponent(args.to || '')}?${params.toString()}`;
    window.open(uri, '_blank');
    return { delivered: true, method: 'mailto', fallbackUri: uri };
}
